/**
 * External Dependencies
 */
import { Application } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";

window.Stimulus = Application.start();
const context = require.context("./controllers", true, /\.js$/);
Stimulus.load(definitionsFromContext(context));

// Font Awesome
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import {
  faFacebookF,
  faFacebook,
  faTwitter,
  faInstagram,
  faXTwitter,
  faLinkedin,
  faThreads
} from '@fortawesome/free-brands-svg-icons';
import { faArrowRight, faArrowLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

// add the imported icons to the library
library.add(faFacebookF, faFacebook, faTwitter, faInstagram, faXTwitter, faLinkedin, faThreads, faArrowLeft, faArrowRight, faChevronRight );

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();

import AOS from 'aos';
AOS.init({
  duration: 500,
  easing: 'ease-in-out',
});